import yup from 'yup'

export default yup.object().shape({
  email: yup.string().required("Email can't be blank")
})



// WEBPACK FOOTER //
// ./src/validations/user.js